// import { getPageFolderName, getPageTypes } from "@config/cms";
import {
  PROMO,
  BANNER,
  CONTENT,
  // NEW_CONTENT,
  ALL_DESTINATIONS,
  ALL_ROUTES,
  LATEST_HERO,
  HERO,
  GALERY_V1,
  GALERY_V2,
  GALERY_V3,
  GALERY_V4,
  GALERY_V5,
  GALERY_V6,
  GALERY_V7,
  TRAVELING,
  OPERATIONS,
  NEWS,
  LATEST,
  POPULAR,
  STOPS,
  CONTACTS,
  GIFT_CARD,
  PROMOS,
  REGISTRATION,
  NEWS_LIST,
  STORY_LIST,
  IFRAME,
} from "./blocks";
// import { firstLetterToUpperCase } from "@utils/utils";

export const commonCollectionTypeFields = {
  isShow: "boolean",
};

export const commonCollectionFields = {
  isShow: true,
};

export const newCollectionTemplate = ({ typeFields, fields, ...rest }) => {
  return {
    typeFields: {
      ...commonCollectionTypeFields,
      ...typeFields,
    },
    itemTemplate: {
      ...commonCollectionFields,
      ...fields,
    },
    ...rest,
  };
};

export const blocksOptionsConfig = {
  collectionTypes: {
    stops: {
      value: "stops",
    },
    routes: {
      value: "routes",
    },
    contactsTabs: {
      value: "contactsTabs",
    },
    popular: {
      value: "popular",
    },
    sliderV1: {
      value: "sliderV1",
    },
    sliderV2: {
      value: "sliderV2",
    },
    sliderV3: {
      value: "sliderV3",
    },
    sliderV4: {
      value: "sliderV4",
    },
    sliderV5: {
      value: "sliderV5",
    },
    sliderV6: {
      value: "sliderV6",
    },
    sliderV7: {
      value: "sliderV7",
    },
    features: {
      value: "features",
    },
    advBanner: {
      value: "advBanner",
    },
  },
  categories: {
    all: {
      value: "all",
    },
    galeries: {
      value: "galeries",
    },
    banners: {
      value: "banners",
    },
    components: {
      value: "components",
    },
    texts: {
      value: "text",
    },
    pictures: {
      value: "pictures",
    },
  },
};

// NOTE: all specific options order starts with 2: 299, 2100, 2101
export const specificBlockOptions = {
  button: {
    buttonStyle: {
      order: 19,
      component: "selectOne",
      title: "Button style",
      options: [
        {
          value: "primary",
          text: "Primary button",
        },
        {
          value: "backLink",
          text: "Back link",
        },
      ],
    },
    position: {
      order: 20,
      component: "selectOne",
      options: [
        {
          value: "left",
          text: "Left",
        },
        {
          value: "center",
          text: "Center",
        },
        {
          value: "right",
          text: "Right",
        },
      ],
    },
  },
  popular: {
    contentType: {
      order: 20,
      component: "selectOne",
      options: [
        {
          value: "routes",
          text: "routes",
        },
        {
          value: "destinations",
          text: "destinations",
        },
      ],
    },
  },
  latestHero: {
    contentType: {
      order: 20,
      component: "selectOne",
      options: [
        {
          value: "news",
          text: "news",
        },
        {
          value: "story",
          text: "story",
        },
        {
          value: "promo",
          text: "promo",
        },
      ],
    },
  },
  latest: {
    contentType: {
      order: 20,
      component: "selectOne",
      options: [
        {
          value: "news",
          text: "news",
        },
        {
          value: "story",
          text: "story",
        },
        {
          value: "promo",
          text: "promo",
        },
      ],
    },
  },
  latestList: {
    contentType: {
      order: 20,
      component: "selectOne",
      options: [
        {
          value: "news",
          text: "news",
        },
        {
          value: "story",
          text: "story",
        },
        {
          value: "promo",
          text: "promo",
        },
        {
          value: "route",
          text: "route",
        },
        {
          value: "destination",
          text: "destination",
        },
      ],
    },
    itemsAmount: {
      order: 21,
      component: "selectOne",
      options: [
        {
          value: "3",
          text: "3",
        },
        {
          value: "6",
          text: "6",
        },
        {
          value: "9",
          text: "9",
        },
      ],
    },
    showPicture: {
      order: 22,
      title: "Picture",
      subTitle: "Toggle the switcher to show/hide picture.",
      titlesInsideComponent: true,
    },
    showDescription: {
      order: 23,
      title: "Description",
      subTitle: "Toggle the switcher to show/hide description.",
      titlesInsideComponent: true,
    },
    showDate: {
      order: 24,
      title: "Date",
      subTitle: "Toggle the switcher to show/hide date.",
      titlesInsideComponent: true,
    },
    showLoadMore: {
      order: 25,
      title: "Show more button",
      subTitle: "Toggle the switcher to show/hide show more button.",
      titlesInsideComponent: true,
    },
  },
  hero: {
    showSearch: {
      order: 20,
      title: "Search component",
      subTitle: "Toggle the switcher to enable/disable search component.",
      titlesInsideComponent: true,
    },
    titleType: {
      order: 22,
      component: "selectOne",
      title: "Content title",
      options: [
        {
          value: "h1",
          text: "H1",
        },
        {
          value: "h2",
          text: "H2",
        },
        // {
        //   value: "type3",
        //   text1: "H3",
        // },
      ],
    },
    subTitleType: {
      order: 23,
      component: "selectOne",
      title: "Content subtitle",
      options: [
        {
          value: "h1",
          text: "h1",
        },
        {
          value: "h2",
          text: "h2",
        },
        {
          value: "paragraph",
          text: "paragraph",
        },
        {
          value: "date",
          text: "date",
        },
        {
          value: "none",
          text: "none",
        },
      ],
    },
    backgroundOption: {
      order: 24,
      component: "selectOne",
      title: "picture positioning",
      options: [
        {
          value: "centerCover",
          text: "center",
        },
        {
          value: "rightContain",
          text: "right",
        },
      ],
    },
    defaultRoute: {
      order: 25,
    },
  },
  content_old: {
    columns: {
      order: 20,
      component: "selectOne",
      title: "Columns",
      subTitle: "",
      options: [
        {
          value: 1,
          text: "1 column",
        },
        {
          value: 2,
          text: "2 column",
        },
        {
          value: 3,
          text: "3 column",
        },
      ],
    },
    picture: {
      order: 21,
      component: "selectOne",
      title: "Picture Positioning",
      subTitle: "",
      options: [
        {
          value: "left",
          text: "Picture on the Left",
        },
        {
          value: "right",
          text: "Picture on the Right",
        },
        {
          value: "none",
          text: "No Picture",
        },
      ],
    },
    titlePosition: {
      order: 22,
      component: "selectOne",
      title: "Title Positioning",
      subTitle: "",
      notice: "Inner positioning will only have an effect on the image layout.",
      options: [
        {
          value: "outside",
          text: "Outside",
        },
        {
          value: "inside",
          text: "Inside",
        },
      ],
    },
    showShareButtons: {
      order: 23,
      title: "Show share buttons",
      subTitle: "Toggle the switcher to enable/disable show share buttons",
      titlesInsideComponent: true,
    },
    showMoreLink: {
      order: 24,
      title: "Show more link",
      subTitle: "Toggle the switcher to enable/disable show more link",
      titlesInsideComponent: true,
    },
    typeOfLink: {
      order: 25,
      component: "selectOne",
      title: "Link type",
      subTitle: "",
      // notice: "Inner positioning will only have an effect on the image layout.",
      options: [
        {
          value: "button",
          text: "Button",
        },
        {
          value: "link",
          text: "Link",
        },
      ],
    },
  },
  content: {
    columns: {
      order: 20,
      component: "selectOne",
      title: "Columns",
      subTitle: "",
      options: [
        {
          value: 1,
          text: "1 column",
        },
        {
          value: 2,
          text: "2 column",
        },
        {
          value: 3,
          text: "3 column",
        },
        {
          value: 4,
          text: "4 column",
        },
      ],
    },
    fullWidth: {
      order: 21,
      title: "Full width",
      subTitle:
        "Allows the text column(s) to either take full width or stay constrained by default.",
      titlesInsideComponent: true,
      notice:
        "This setting applies when no component is used and 3 or fewer columns are selected.",
    },
    component: {
      order: 22,
      component: "selectOne",
      title: "Insert component",
      subTitle: "",
      options: [
        {
          value: 1,
          text: "Graphic File",
        },
        {
          value: 2,
          text: "Latest",
        },
        {
          value: 3,
          text: "Banner",
        },
        {
          value: 4,
          text: "none",
        },
      ],
    },
    titlePosition: {
      order: 23,
      component: "selectOne",
      title: "Title Positioning",
      subTitle: "",
      notice: "Inner positioning will only have an effect on the image layout.",
      options: [
        {
          value: "outside",
          text: "Outside",
        },
        {
          value: "inside",
          text: "Inside",
        },
      ],
    },
    componentPosition: {
      order: 24,
      component: "selectOne",
      title: "Component Positioning",
      subTitle: "",
      options: [
        {
          value: "left",
          text: "Left",
        },
        {
          value: "right",
          text: "Right",
        },
      ],
    },
    componentContentType: {
      order: 25,
      component: "selectOne",
      title: "Component content type",
      subTitle: "",
      options: [
        {
          value: "news",
          text: "news",
        },
        {
          value: "story",
          text: "story",
        },
        // {
        //   value: 'promo',
        //   text: 'promo',
        // },
        {
          value: "destination",
          text: "destination",
        },
        {
          value: "route",
          text: "route",
        },

        // {
        //   value: getPageTypes().news,
        //   text: firstLetterToUpperCase(getPageFolderName().news),
        // },
        // {
        //   value: getPageTypes().story,
        //   text: firstLetterToUpperCase(getPageFolderName().story),
        // },
        // {
        //   value: getPageTypes().promo,
        //   text: firstLetterToUpperCase(getPageFolderName().promo),
        // },
        // {
        //   value: getPageTypes().destination,
        //   text: firstLetterToUpperCase(getPageFolderName().destination),
        // },
        // {
        //   value: getPageTypes().route,
        //   text: firstLetterToUpperCase(getPageFolderName().route),
        // },
      ],
    },
    showShareButtons: {
      order: 26,
      title: "Show share buttons",
      subTitle: "Toggle the switcher to enable/disable show share buttons",
      titlesInsideComponent: true,
    },
    showMoreLink: {
      order: 27,
      title: "Show more link",
      subTitle: "Toggle the switcher to enable/disable show more link",
      titlesInsideComponent: true,
    },
    linkPosition: {
      order: 28,
      component: "selectOne",
      title: "Link position",
      subTitle: "",
      options: [
        {
          value: "left",
          text: "Left",
        },
        {
          value: "center",
          text: "Center",
        },
        {
          value: "right",
          text: "Right",
        },
      ],
    },
    typeOfLink: {
      order: 29,
      component: "selectOne",
      title: "Link type",
      subTitle: "",
      // notice: "Inner positioning will only have an effect on the image layout.",
      options: [
        {
          value: "button",
          text: "Button",
        },
        {
          value: "link",
          text: "Link",
        },
      ],
    },
    // picture: {
    //   order: 28,
    //   component: "selectOne",
    //   title: "Picture Positioning (OLD setting)",
    //   subTitle: "",
    //   options: [
    //     {
    //       value: "left",
    //       text: "Picture on the Left",
    //     },
    //     {
    //       value: "right",
    //       text: "Picture on the Right",
    //     },
    //     {
    //       value: "none",
    //       text: "No Picture",
    //     },
    //   ],
    // },
  },
  newContent: {
    columns: {
      order: 20,
      component: "selectOne",
      title: "Columns",
      subTitle: "",
      options: [
        {
          value: 1,
          text: "1 column",
        },
        {
          value: 2,
          text: "2 column",
        },
        {
          value: 3,
          text: "3 column",
        },
        {
          value: 4,
          text: "4 column",
        },
      ],
    },
    component: {
      order: 21,
      component: "selectOne",
      title: "Insert component",
      subTitle: "",
      options: [
        {
          value: 1,
          text: "Picture",
        },
        {
          value: 2,
          text: "Latest",
        },
        {
          value: 3,
          text: "Banner",
        },
        {
          value: 4,
          text: "none",
        },
      ],
    },
    titlePosition: {
      order: 22,
      component: "selectOne",
      title: "Title Positioning",
      subTitle: "",
      notice: "Inner positioning will only have an effect on the image layout.",
      options: [
        {
          value: "outside",
          text: "Outside",
        },
        {
          value: "inside",
          text: "Inside",
        },
      ],
    },
    componentPosition: {
      order: 23,
      component: "selectOne",
      title: "Component Positioning",
      subTitle: "",
      options: [
        {
          value: "left",
          text: "Left",
        },
        {
          value: "right",
          text: "Right",
        },
      ],
    },
    componentContentType: {
      order: 24,
      component: "selectOne",
      title: "Component content type",
      subTitle: "",
      options: [
        {
          value: "news",
          text: "news",
        },
        {
          value: "story",
          text: "story",
        },
        // {
        //   value: 'promo',
        //   text: 'promo',
        // },
        {
          value: "destination",
          text: "destination",
        },
        {
          value: "route",
          text: "route",
        },

        // {
        //   value: getPageTypes().news,
        //   text: firstLetterToUpperCase(getPageFolderName().news),
        // },
        // {
        //   value: getPageTypes().story,
        //   text: firstLetterToUpperCase(getPageFolderName().story),
        // },
        // {
        //   value: getPageTypes().promo,
        //   text: firstLetterToUpperCase(getPageFolderName().promo),
        // },
        // {
        //   value: getPageTypes().destination,
        //   text: firstLetterToUpperCase(getPageFolderName().destination),
        // },
        // {
        //   value: getPageTypes().route,
        //   text: firstLetterToUpperCase(getPageFolderName().route),
        // },
      ],
    },
    showShareButtons: {
      order: 25,
      title: "Show share buttons",
      subTitle: "Toggle the switcher to enable/disable show share buttons",
      titlesInsideComponent: true,
    },
    showMoreLink: {
      order: 26,
      title: "Show more link",
      subTitle: "Toggle the switcher to enable/disable show more link",
      titlesInsideComponent: true,
    },
    typeOfLink: {
      order: 27,
      component: "selectOne",
      title: "Link type",
      subTitle: "",
      // notice: "Inner positioning will only have an effect on the image layout.",
      options: [
        {
          value: "button",
          text: "Button",
        },
        {
          value: "link",
          text: "Link",
        },
      ],
    },
    // picture: {
    //   order: 28,
    //   component: "selectOne",
    //   title: "Picture Positioning (OLD setting)",
    //   subTitle: "",
    //   options: [
    //     {
    //       value: "left",
    //       text: "Picture on the Left",
    //     },
    //     {
    //       value: "right",
    //       text: "Picture on the Right",
    //     },
    //     {
    //       value: "none",
    //       text: "No Picture",
    //     },
    //   ],
    // },
  },
  banner: {
    picture: {
      order: 20,
      component: "selectOne",
      title: "Picture Positioning",
      subTitle: "",
      options: [
        {
          value: "left",
          text: "Picture on the Left",
        },
        {
          value: "right",
          text: "Picture on the Right",
        },
        {
          value: "none",
          text: "No Picture",
        },
      ],
    },
    titlePosition: {
      order: 21,
      component: "selectOne",
      title: "Title Positioning",
      subTitle: "",
      notice: "Inner positioning will only have an effect on the image layout.",
      options: [
        {
          value: "outside",
          text: "Outside",
        },
        {
          value: "inside",
          text: "Inside",
        },
      ],
    },
    showMoreLink: {
      order: 22,
      title: "Show more link",
      subTitle: "Toggle the switcher to enable/disable show more link",
      titlesInsideComponent: true,
    },
    typeOfLink: {
      order: 23,
      component: "selectOne",
      title: "Link type",
      subTitle: "",
      // notice: "Inner positioning will only have an effect on the image layout.",
      options: [
        {
          value: "button",
          text: "Button",
        },
        {
          value: "link",
          text: "Link",
        },
      ],
    },
  },
  iframe: {
    iframeString: {
      order: 23,
      component: "iframe",
      title: "Iframe tag",
      // titlesInsideComponent: true,
      notice:
        "Please, ensure your iFrame code is valid HTML, uses proper attributes(src, width, height), and adheres to security best practices.",
    },
  },
  promos: {
    showActive: {
      order: 20,
      title: "Show active promos",
      subTitle: "Toggle the switcher to show/hide active promos.",
      titlesInsideComponent: true,
    },
    showPassed: {
      order: 21,
      title: "Show passed promos",
      subTitle: "Toggle the switcher to show/hide passed promos.",
      titlesInsideComponent: true,
    },
  },
};

// NOTE: all common options order starts with 1: 199, 1100, 1101
export const commonBlocksOptions = {
  blockType: {
    order: 10,
    component: "blockType",
    title: "Title & Indent",
    options: [
      {
        value: "type1",
        text1: "H2",
        text2: "100px",
      },
      {
        value: "type2",
        text1: "H3",
        text2: "100px",
      },
      {
        value: "type3",
        text1: "",
        text2: "100px",
      },
      {
        value: "type7",
        text1: "",
        text2: "80px",
      },
      {
        value: "type4",
        text1: "",
        text2: "60px",
      },
      {
        value: "type5",
        text1: "",
        text2: "20px",
      },
      {
        value: "type6",
        text1: "",
        text2: "0px",
      },
    ],
  },
  titleColor: {
    order: 21,
    // component: "colorPicker",
    title: "Title color",
    subTitle: "Enter the color in hex format",
    // options: [],
  },
  useWindowHeight: {
    order: 32,
    title: "Block Height Setting",
    subTitle:
      "Enable to set the block height equal to the browser window height",
    titlesInsideComponent: true,
  },
};

export const defaultBlockSettings = {
  common: {
    blockType: {
      component: "blockType",
      value: commonBlocksOptions.blockType.options[0].value,
    },
    titleColor: {
      component: "colorPicker",
      value: "",
    },
    useWindowHeight: {
      component: "switcher",
      value: false,
    },
  },
  specific: {
    // [CONTENT]: {
    //   columns: {
    //     component: "selectOne",
    //     value: specificBlockOptions.content.columns.options[0].value,
    //   },
    //   picture: {
    //     component: "selectOne",
    //     value: specificBlockOptions.content.picture.options[2].value,
    //   },
    //   titlePosition: {
    //     component: "selectOne",
    //     value: specificBlockOptions.content.titlePosition.options[0].value,
    //   },
    //   showMoreLink: {
    //     component: "switcher",
    //     value: false,
    //   },
    //   showShareButtons: {
    //     component: "switcher",
    //     value: false,
    //   },
    //   typeOfLink: {
    //     component: "selectOne",
    //     value: specificBlockOptions.content.typeOfLink.options[0].value,
    //   },
    // },
    [CONTENT]: {
      columns: {
        component: "selectOne",
        value: specificBlockOptions.content.columns.options[0].value,
      },
      fullWidth: {
        component: "switcher",
        value: false,
      },
      component: {
        component: "selectOne",
        value: specificBlockOptions.content.component.options[0].value,
      },
      componentPosition: {
        component: "selectOne",
        value: specificBlockOptions.content.componentPosition.options[1].value,
      },
      componentContentType: {
        component: "selectOne",
        value:
          specificBlockOptions.content.componentContentType.options[0].value,
      },
      // picture: {
      //   component: "selectOne",
      //   value: specificBlockOptions.content.picture.options[2].value,
      // },
      titlePosition: {
        component: "selectOne",
        value: specificBlockOptions.content.titlePosition.options[0].value,
      },
      showMoreLink: {
        component: "switcher",
        value: false,
      },
      showShareButtons: {
        component: "switcher",
        value: false,
      },
      linkPosition: {
        component: "selectOne",
        value: specificBlockOptions.content.linkPosition.options[0].value,
      },
      typeOfLink: {
        component: "selectOne",
        value: specificBlockOptions.content.typeOfLink.options[0].value,
      },
    },
    // [IFRAME]: {
    //   iframeString:''
    // }
    // [PROMO]: {},
    // [BANNER]: {},
    // [ALL_DESTINATIONS]: {},
    // [ALL_ROUTES]: {},
    // [LATEST_HERO]: {},
    // [HERO]: {},
    // [GALERY_V1]: {},
    // [GALERY_V2]: {},
    // [GALERY_V3]: {},
    // [GALERY_V4]: {},
    // [GALERY_V5]: {},
    // [GALERY_V6]: {},
    // [GALERY_V7]: {},
    // [TRAVELING]: {},
    // [OPERATIONS]: {},
    // [NEWS]: {},
    // [LATEST]: {},
    // [POPULAR]: {},
    // [STOPS]: {},
    // [CONTACTS]: {},
    // [GIFT_CARD]: {},
    // [PROMOS]: {},
    // [REGISTRATION]: {},
    // [NEWS_LIST]: {},
    // [STORY_LIST]: {},
  },
};
